import React from 'react';
import { useSelector } from 'react-redux';
import { getUserData } from '../../redux/selectors/userData';
import { useFeatureFlag } from '../../hooks';
import FlyingPage from '../flying';
import FlyingPageV2 from '../flying-v2';

const HomePage = () => {
  const userData = useSelector(getUserData);
  const { orgs = [] } = userData;
  const userOrgIds = orgs.reduce<string[]>((acc, o) => acc.concat(o.org.id), []);

  const isHideLegacyFlyingPageEnabled = useFeatureFlag('hide-legacy-flying-page', userOrgIds);
  if (isHideLegacyFlyingPageEnabled) {
    return <FlyingPageV2 />;
  }

  return <FlyingPage />;
};

export default HomePage;
